import {
  AddEquation,
  BackSide,
  CustomBlending,
  MeshBasicMaterial,
  OneFactor,
  OneMinusSrcAlphaFactor,
  RGBAFormat,
  SphereBufferGeometry,
  Spherical,
  Vector2,
  Vector3,
  VideoTexture
} from 'three'

import {getLangValue, PANO_CONFIG} from './PanoConfig'

/**
 * 根据父级内容和动画内容创建覆盖范围
 * @param {number} left 左边距
 * @param {number} top 上边距
 * @param {number} pW 容器宽度
 * @param {number} pH 容器高度
 * @param {number} cW 内容宽度
 * @param {number} cH 内容高度
 */
function createPanoContentGeo (
  left,
  top,
  pW,
  pH,
  cW,
  cH,
  ratio = 1,
  panoRatio = 1
) {
  // 父级尺寸
  let pVec = new Vector2(pW, pH)
  // 子尺寸
  let cVec = new Vector2(cW, cH)
  cVec.multiplyScalar(ratio)
  // 内容偏移比例
  let ratioTheta = Math.PI / pVec.height
  let ratioPhi = (Math.PI * 2) / pVec.width
  // 计算动画偏移
  let thetaStart = top * ratio * ratioTheta
  let phiStart = left * ratio * ratioPhi
  // 计算动画内容占位
  let contentPhi = cVec.width * ratioPhi
  let contentTheta = cVec.height * ratioTheta
  let geo = new SphereBufferGeometry(
    PANO_CONFIG.PAN_RATIO * panoRatio,
    PANO_CONFIG.PAN_W_SEG,
    PANO_CONFIG.PAN_H_SEG,
    phiStart,
    contentPhi,
    thetaStart,
    contentTheta
  )
  return geo
}

/**
 * 获取全景中的一个定位
 * @param {number} left
 * @param {number} top
 * @param {number} pW
 * @param {number} pH
 * @param {number} ratio
 */
function getPanoPosition (left, top, pW, pH, ratio) {
  // 父级尺寸
  let pVec = new Vector2(pW, pH)
  // 子尺寸
  let cVec = new Vector2(left, top)
  cVec.multiplyScalar(ratio)
  // 计算球坐标和平面坐标比例
  let ratioTheta = (Math.PI * 2) / pVec.width
  let ratioPhi = Math.PI / pVec.height
  // 计算极 坐标
  let theta = cVec.x * ratioTheta
  let phi = cVec.y * ratioPhi

  // 因为全景球进行过反向缩放, 所以水平需要取反值
  theta = -theta

  // 因为全景球进行过反向缩放, 所以水平需要偏移  1/2 π
  theta += Math.PI / 2

  let sphere = new Spherical(PANO_CONFIG.PAN_RATIO, phi, theta)
  return new Vector3().setFromSpherical(sphere)
}

/**
 * 求平面移动最短路径
 */
function getVecMinMove (startX, endX, PW) {
  // 以最小夹角进行旋转
  // let newSph: Spherical = spherical_;
  // let curSph: Spherical = this._curSperical;
  // if (Math.abs(newSph.theta - curSph.theta) > Math.PI) {
  //   if (curSph.theta < 0 && newSph.theta > 0) {
  //     newSph.theta = -Math.PI - (Math.PI - newSph.theta);
  //   } else if (curSph.theta > 0 && newSph.theta < 0) {
  //     newSph.theta = Math.PI + (Math.PI + newSph.theta);
  //   }
  // }

  // 以最小夹角进行旋转
  let newSph = new Spherical(100, Math.PI, 0)
  let curSph = new Spherical(100, Math.PI, 0)

  newSph.theta = (endX / PW) * (Math.PI * 2)
  curSph.theta = (startX / PW) * (Math.PI * 2)

  if (Math.abs(newSph.theta - curSph.theta) > Math.PI) {
    if (curSph.theta < 0 && newSph.theta > 0) {
      newSph.theta = -Math.PI - (Math.PI - newSph.theta)
    } else if (curSph.theta > 0 && newSph.theta < 0) {
      newSph.theta = Math.PI + (Math.PI + newSph.theta)
    }
  }
  newSph.makeSafe()
  let trueX = (newSph.theta / (Math.PI * 2)) * PW
  console.log('truest X:',trueX," end X:",endX);
}

/**
 * 创建动画材质
 */
function createAniMeshBasicMaterial (ani) {
  // 需要透明?
  let material = null
  let texture = createVideoTexture(ani)
  if (ani.transparent) {
    texture.format = RGBAFormat
    material = new MeshBasicMaterial({
      map: texture,
      side: BackSide,
      depthTest: false,
      blending: CustomBlending,
      blendEquation: AddEquation,
      blendSrc: OneFactor,
      blendDst: OneMinusSrcAlphaFactor
    })
  } else {
    material = new MeshBasicMaterial({
      map: texture,
      side: BackSide
    })
  }
  return material
}

/** * 创建视频材质 */
function createVideoTexture (ani) {
  var videoDom = document.createElement('video')
  videoDom.src = getLangValue(ani.texture_cn, ani.texture_en)
  videoDom.loop = ani.loop
  videoDom.autoplay = ani.autoplay
  if (videoDom.autoplay) {
    videoDom.muted = true
    videoDom.play()
  }
  var texture = new VideoTexture(videoDom)
  texture.needsUpdate = true
  return texture
}

/**
 * 根据url地址创建 VideoTextrue
 * @param src
 * @returns {VideoTexture}
 */
function createPureVideoTexture (src) {
  var videoDom = document.createElement('video')
  videoDom.src = src
  videoDom.loop = true
  videoDom.autoplay = true
  if (videoDom.autoplay) {
    videoDom.muted = true
    videoDom.play()
  }
  var texture = new VideoTexture(videoDom)
  texture.needsUpdate = true
  return texture
}

export {
  createVideoTexture,
  createPureVideoTexture,
  createPanoContentGeo,
  getPanoPosition,
  getVecMinMove,
  createAniMeshBasicMaterial
}



// WEBPACK FOOTER //
// ./src/webgl/panorama/utils.js